import { render, staticRenderFns } from "./LineIcon.vue?vue&type=template&id=524f4ac0&scoped=true"
import script from "./LineIcon.vue?vue&type=script&lang=js"
export * from "./LineIcon.vue?vue&type=script&lang=js"
import style0 from "./LineIcon.vue?vue&type=style&index=0&id=524f4ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f4ac0",
  null
  
)

export default component.exports